export default __webpack_public_path__ + "static/media/collections_5.5223934c.jpg";